<template>
  <div>
    <v-container grid-list-xl fluid class="pa-2 px-3">
      <v-layout row wrap class="pr-5 pl-2">
        <v-flex xs6 mb-3 class="pb-0">
          <h3 class="title darkblue--text breadcrumbs text-uppercase">
            shopper activities
          </h3>
          <v-breadcrumbs
            class="px-0 subtitle-2 mt-0 pt-0 pb-1 breadcrumbs-items"
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
        <v-spacer></v-spacer>
        <dialog-add-roi
          v-if="isLoggedInAsBO"
          class="mt-8"
          typeModal="add"
          @getlistData="getData"
        />
        <v-btn color="primary" class="mt-8 ml-2" @click="downloadFile">
          <v-icon dark class="mr-2">mdi-cloud-download</v-icon> Download
        </v-btn>
      </v-layout>
    </v-container>

    <v-layout class="px-5 pb-5">
      <v-flex xs12>
        <v-card class="pb-5">
          <v-card-title class="primary titleDetail py-1 px-2 white--text">
            <span class="title pl-2 text-uppercase">shopper activities</span>
            <v-spacer></v-spacer>
            <v-icon
              color="white"
              class="mr-2"
              id="refreshBudget"
              @click="getData"
            >
              refresh
            </v-icon>
          </v-card-title>
          <ValidationObserver ref="obs">
            <v-card-text class="px-2 py-2">
              <!-- ROI -->
              <spending-report-roi
                :itemsCard="itemsRoi"
                :isloginBO="isLoggedInAsBO"
                @getlistData="getData"
              />
            </v-card-text>
          </ValidationObserver>
        </v-card>
      </v-flex>
    </v-layout>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../components/progress_dialog';
import ACLMixin from '../../mixins/ACLMixin';
import Swal from 'sweetalert2';
// import moment from 'moment';
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SpendingReportRoi from '@/components/SpendingReport/SpendingReportRoi';
import DialogAddRoi from '@/components/SpendingReport/DialogAddRoi';
import LoginAsMixin from '@/mixins/LoginAsMixin';

export default {
  components: {
    SpendingReportRoi,
    DialogAddRoi,
    'progress-dialog': ProgressDialog
    // VuePerfectScrollbar
  },
  mixins: [ACLMixin, LoginAsMixin],
  data() {
    return {
      progressDialogLoading: false,
      itemsRoi: [],
      breadcrumbs: [
        {
          text: 'MROI',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'SHOPPER ACTIVITIES',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      baseUrl: process.env.VUE_APP_BASE_URL
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      this.$store
        .dispatch('mroi/getAll')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.itemsRoi = data.data;
            // if (this.roiType === 'PROMOTIONAL OBJECTS') {
            //   this.itemsRoi = data.data.roi_gimmick;
            // } else if (this.roiType === 'CRM') {
            //   this.itemsRoi = data.data.roi_crm;
            // }
            // this.itemsRoi = Number(data.data.total);
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    downloadFile() {
      if (this.itemsRoi.length === 0) {
        Swal.fire('Failed!', 'No Data Available', 'error');
      } else {
        let profile_id = localStorage.getItem('profile_id');
        window.open(
          this.baseUrl +
            '/v1/roi/report/download?profile_id=' +
            profile_id +
            '&token=' +
            localStorage.getItem('app_token'),
          '_blank'
        );
      }
    }
  }
};
</script>
<style></style>
